export default __webpack_public_path__ + "static/media/j18.3f99ecb9.jpg";